import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import SstPostsList from './SstPostsList'
import SstPostProfile from './SstPostProfile'

export default function SstPosts() {
	return (
		<React.Fragment>
			<Switch>
				<Route exact path="/sst_posts" component={SstPostsList} />
				<Route exact path="/sst_posts/:id" component={SstPostProfile} />

				<Redirect to="/404" />
			</Switch>
		</React.Fragment>
	)
}